<template>
    <div>
        <div class="product-fabric-part-3-container">
            <CommonComponentsProductsTitleFunctionTitle
                :function-title="data.functionTitle"
                :color-index="data.functionTitleColorIndex"
            />
            <div class="product-fabric-part-3-info">
                <div class="product-fabric-part-3-img">
                    <CommonComponentsVideoPlayer
                        class="fabric-timeline-video-elmt"
                        :sources="[
                            {
                                src: mediaPath,
                                type: 'video/mp4',
                            },
                        ]"
                        :poster="poster"
                        :autoplay="true"
                    />
                </div>
                <div class="product-fabric-content-text-container">
                    <div v-for="(p3text, textIndex) in data.part3Data.texts" :key="textIndex">
                        <CommonComponentsTextWithCheckIcon>
                            <span class="fabric-text-scroll" v-html="$t(p3text)" />
                        </CommonComponentsTextWithCheckIcon>
                    </div>
                </div>
            </div>
        </div>
        <div class="product-fabric-samples-grid">
            <div
                v-for="(sampleItem, sampleIndex) in data.part3Data.samples"
                :key="sampleIndex"
                class="product-fabric-sample-flex fabric-slide-in-up"
            >
                <div class="product-fabric-sample-img">
                    <img :data-src="`${sampleItem.imgPath}`" class="lazy" alt="" />
                </div>
                <!-- <div class="product-fabric-sample-text" v-html="$t(sampleItem.text)" /> -->
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import poster from '@assets/Video/products/fabric/procedure4.jpg';
    import mediaPath from '@assets/Video/products/fabric/procedure4.mp4';

    import p3img2 from '@assets/imgs/Products/Fabric/p3img2.png';
    import p3img3 from '@assets/imgs/Products/Fabric/p3img3.png';
    import p3img4 from '@assets/imgs/Products/Fabric/p3img4.png';
    import p3img5 from '@assets/imgs/Products/Fabric/p3img5.png';
    import p3img6 from '@assets/imgs/Products/Fabric/p3img6.png';
    import p3img7 from '@assets/imgs/Products/Fabric/p3img7.png';
    const data = reactive({
        functionTitle: {
            colorTitle: 'global_fabric_colorTitle',
            title: 'global_fabric_title_2',
            subTitle: 'global_fabric_subTitle_2',
        },
        functionTitleColorIndex: 1,
        part3Data: {
            texts: [
                'global_fabric_content_text_26',
                'global_fabric_content_text_27',
                'global_fabric_content_text_28',
                'global_fabric_content_text_29',
            ],
            samples: [
                {
                    imgPath: p3img2,
                    text: 'global_fabric_content_text_20',
                },
                {
                    imgPath: p3img3,
                    text: 'global_fabric_content_text_21',
                },
                {
                    imgPath: p3img4,
                    text: 'global_fabric_content_text_22',
                },
                {
                    imgPath: p3img5,
                    text: 'global_fabric_content_text_23',
                },
                {
                    imgPath: p3img6,
                    text: 'global_fabric_content_text_24',
                },
                {
                    imgPath: p3img7,
                    text: 'global_fabric_content_text_25',
                },
            ],
        },
    });
</script>

<style lang="less" scoped>
    .product-fabric-part-3-container {
        border-radius: 40px;
        padding-left: .convert(80px) [ @vw];
        // padding-right: .convert(30px) [ @vw];

        .product-fabric-part-3-info {
            display: grid;
            // height: .convert(613px) [ @vh];
            position: relative;
            .product-fabric-content-text-container {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                gap: .convert(26px) [ @vw];
                font-family: 'HarmonyOS Sans SC';
                width: .convert(500px) [ @vw];
                margin-top: .convert(318px) [ @vw];

                margin-bottom: .convert(52px) [ @vw];

                :deep(.check-icon) {
                    margin-right: .convert(5px) [ @vw];
                }
            }

            .product-fabric-part-3-img {
                width: .convert(869px) [ @vw];
                position: absolute;
                bottom: 0;
                right: 0;
                video {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        @media (max-width: @screen-mobile-width) {
            border-radius: 20px;
            background: #161616;
            padding: .convert(20px) [ @vw-mobile];
            :deep(.function-subtitle) {
                margin-top: .convert(10px) [ @vw-mobile];
                font-size: .convert(13px) [ @vw-mobile];
            }

            .product-fabric-part-3-info {
                display: flex;
                flex-direction: column;
                height: auto;
                .product-fabric-content-text-container {
                    margin-top: 0;
                    gap: .convert(15px) [ @vw-mobile];
                    width: 100%;
                }
                .product-fabric-part-3-img {
                    position: relative;
                    display: flex;
                    justify-content: center;
                    left: 0;
                    margin: 0px 0px 20px 0px;
                    width: .convert(303px) [ @vw-mobile];
                    @media (max-width: @screen-mobile-width) {
                        margin-top: .convert(20px) [ @vw-mobile];
                    }
                    video {
                        width: 100%;
                        height: auto;
                    }
                }
            }
        }
    }

    .product-fabric-samples-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: repeat(2, 1fr);
        grid-column-gap: .convert(20px) [ @vw];
        grid-row-gap: .convert(20px) [ @vw];
        width: 100%;
        margin-top: .convert(100px) [ @vw];

        .product-fabric-sample-flex {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: .convert(20px) [ @vw];

            .product-fabric-sample-img {
                img {
                    width: 100%;
                    height: auto;
                }
            }

            .product-fabric-sample-text {
                font-size: .convert(@font-size-xl) [ @vw];
            }
        }

        @media (max-width: @screen-mobile-width) {
            grid-template-columns: repeat(2, 1fr);
            grid-template-rows: repeat(3, 1fr);
            grid-column-gap: .convert(5px) [ @vw-mobile];
            grid-row-gap: .convert(10px) [ @vw-mobile];
        }
    }
    :lang(en) {
        .product-fabric-part-3-container {
            .product-fabric-content-text-container {
                margin-top: .convert(269px) [ @vw];
                margin-bottom: .convert(18px) [ @vw];
                width: .convert(390px) [ @vw];
                @media (max-width: @screen-mobile-width) {
                    width: .convert(320px) [ @vw-mobile];
                    margin-top: .convert(0px) [ @vw];
                }
            }
        }
    }
</style>
